import { type Appointment } from "@repo/api";
import { type ActionType, createAction, getType } from "typesafe-actions";

export interface SearchAppointmentState {
  isLoading: boolean;
  searchValue?: string;
  initiallySelectedAppointments?: string[];
  selectedAppointment?: Appointment;
}

export const SearchAppointmentStateDefault: SearchAppointmentState = {
  isLoading: false,
  searchValue: undefined,
};

export type SearchAppointmentStateActions =
  typeof searchAppointmentStateActions;

export const searchAppointmentStateActions = {
  setIsLoading: createAction("SET_IS_LOADING")<boolean>(),
  setSearchValue: createAction("SET_SEARCH_VALUE")<string | undefined>(),
  setSelectedAppointment: createAction("SET_SELECTED")<
    Appointment | undefined
  >(),
};

export function searchAppointmentStateReducer(
  state: SearchAppointmentState,
  action: ActionType<SearchAppointmentStateActions>
): SearchAppointmentState {
  switch (action.type) {
    case getType(searchAppointmentStateActions.setIsLoading):
      return {
        ...state,
        isLoading: action.payload,
      };
    case getType(searchAppointmentStateActions.setSearchValue):
      return {
        ...state,
        searchValue: action.payload,
      };
    case getType(searchAppointmentStateActions.setSelectedAppointment):
      return {
        ...state,
        selectedAppointment: action.payload,
      };
  }
}
